// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"197":"bd5dc0039775c8e5","270":"ee1d232599d3488d","888":"6490c4954923e2a7","976":"6bd6da000b3b47ad"}[chunkId] + ".css";
};